import { z } from 'zod'

export const resetPasswordFormSchema = z
  .object({
    password: z.string().min(1, 'auth:errors.passwordRequired').min(8, 'auth:errors.weakPassword'),
    confirmPassword: z.string().min(1, 'auth:errors.confirmPasswordRequired'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'auth:errors.passwordMismatch',
    path: ['confirmPassword'],
  })

export type ResetPasswordFormValues = z.infer<typeof resetPasswordFormSchema>

export const defaultResetPasswordValues: ResetPasswordFormValues = {
  password: '',
  confirmPassword: '',
}
